module.exports = "<div class=row> <div class=col-xs-3> <div class=form-group> <app-widgets-label i18n-label=Subtype i18n-help=\"Subtype Help\"></app-widgets-label> <select class=form-control required ng-model=poi.marking_point_type ng-options=\"option as (option | appTranslateEnum:'marking_point_type') for option in $ctrl.markingPointTypes\"> </select> </div> </div> </div> <ng-include src=\"'app/poi/edit/general/partial_descriptions.html'\"></ng-include> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/edit/general/partial_marking_point.html
// module id = 434
// module chunks = 0